import {type Routes} from "@angular/router";

export const routes: Routes = [
  // Root
  {
    path: "",
    pathMatch: "full",
    loadComponent: () => import("./sites/home/home.component").then(m => m.HomeComponent),
  },

  {
    path: "news",
    // Note: /news/rss is handled by the express server
    children: [
      {
        path: "",
        loadComponent: () => import("./sites/news/news.component").then(m => m.NewsComponent),
      },
      {
        path: ":id",
        loadComponent: () => import("./sites/news/news.component").then(m => m.NewsComponent),
        data: {
          hideFromSitemap: true, // cause params...
        },
      },
    ],
  },
  {
    path: "projects",
    loadComponent: () => import("./sites/projects/projects.component").then(m => m.ProjectsComponent),
  },
  {
    path: "services",
    loadComponent: () => import("./sites/services/services.component").then(m => m.ServicesComponent),
  },
  {
    path: "about-us",
    loadComponent: () => import("./sites/about-us/about-us.component").then(m => m.AboutUsComponent),
  },
  {
    path: "contact",
    loadComponent: () => import("./sites/contact/contact.component").then(m => m.ContactComponent),
  },
  {
    path: "imprint",
    loadComponent: () => import("./sites/imprint/imprint.component").then(m => m.ImprintComponent),
  },
  {
    path: "disclaimer",
    loadComponent: () => import("./sites/disclaimer/disclaimer.component").then(m => m.DisclaimerComponent),
  },
  {
    path: "privacy",
    loadComponent: () => import("./sites/privacy/privacy.component").then(m => m.PrivacyComponent),
  },

  // Old, redirected routes
  {path: "projekte", redirectTo: "/projects", data: {hideFromSitemap: true}},
  {path: "dienstleistungen", redirectTo: "/services", data: {hideFromSitemap: true}},
  {path: "ueber-uns", redirectTo: "/about-us", data: {hideFromSitemap: true}},
  {path: "kontakt", redirectTo: "/contact", data: {hideFromSitemap: true}},
  {path: "impressum", redirectTo: "/imprint", data: {hideFromSitemap: true}},
  {path: "datenschutz", redirectTo: "/privacy", data: {hideFromSitemap: true}},
];
